module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAUBAMAAABhbjCNAAAALVBMVEUAAAAeHh4XFxcZGRkaGhoYGBgZGRkaGhoYGBgZGRkaGhoZGRkZGRkZGRkZGRki3IYZAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAo0lEQVQY02NgAAHvd1sY4IDjunFtA5yXK8DAeA3Ou8J0V8EXxmG9wJt2gTcAymNfwGt8gasAzmN9FwDnMT9gUGLgc4CbAsRwUxiqgHgFnMdrwMD8EMrmXNW+gYG7YtUEMK+mPOE6Qy1b+XEQh/ExA4Of0hMGBjsBkJMXAPFuoG1cIIfrGQCJ3SBrH6EY3cWAMJqBQc6AgafZGAYsDjD4vUOAJwAhUjLPeVHDhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/item-geo.png
// module id = 659
// module chunks = 0